import React from 'react'
import { Grid as BaseGrid, styled } from '@mui/material'

export const Column = styled(({ margin, padding, width, ...props }) => <BaseGrid item {...props} />)`
  &.MuiGrid-root {
    margin: ${props => props.margin || '0'};
    padding: ${props => props.padding || '0 5px'};
    width: ${props => props.width};
  }
`
